var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('motivo-anul-rech-modals',{attrs:{"modelName":_vm.model}}),_c('pui-datatable',{attrs:{"modelName":_vm.model,"actions":_vm.actions,"showFilterListBtn":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }